function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS, LLOYDS2023 } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.07 0v5.02h5.83L16.07 0zm1.005 11.347H6.825V9.64h10.25v1.707zm0 4.419H6.825v-1.808h10.25v1.808zm0 4.318H6.825v-1.707h10.25v1.707zM14.764 0H2v24h20V6.326h-7.236V0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.068,1 C15.3282675,1 15.5782806,1.10147184 15.7649289,1.28285975 L15.7649289,1.28285975 L20.6969289,6.07585975 C20.8906805,6.26415081 21,6.52282744 21,6.793 L21,6.793 L21,21 C21,22.1045695 20.1045695,23 19,23 L19,23 L5,23 C3.8954305,23 3,22.1045695 3,21 L3,21 L3,3 C3,1.8954305 3.8954305,1 5,1 L5,1 Z M5,3 L5,21 L19,21 L19,9 L15,9 C13.9456382,9 13.0818349,8.18412221 13.0054857,7.14926234 L13,7 L13,3 L5,3 Z M18.778,7 L15,3.328 L15,7 L18.778,7 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.07 0v5.02h5.83L16.07 0zm1.005 11.347H6.825V9.64h10.25v1.707zm0 4.419H6.825v-1.808h10.25v1.808zm0 4.318H6.825v-1.707h10.25v1.707zM14.764 0H2v24h20V6.326h-7.236V0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 5H13V6.3H18V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10H6V11.3H18V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13H6V14.3H18V13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16H6V17.3H13V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 2V22H15.41C15.94 22 16.45 21.79 16.82 21.41L20.41 17.82C20.79 17.44 21 16.94 21 16.41V2H3ZM19.7 16.5C19.7 16.78 19.48 17 19.2 17H16V20.2C16 20.48 15.78 20.7 15.5 20.7H4.3V3.3H19.7V16.5Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
export default function (_ref) {
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var svg;
  switch (brand) {
    case LLOYDS:
      svg = LloydsIcon;
      break;
    case BOS:
      svg = BosIcon;
      break;
    case BIRMINGHAM_MIDSHIRES:
    case HALIFAX:
      svg = HalifaxIcon;
      break;
    case LLOYDS2023:
      svg = Lloyds2023Icon;
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn("Icon is not available in brand \"".concat(brand, "\"."));
      svg = function svg() {
        return null;
      };
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}